// App .egp-app
import React, { Component } from "react";
import Utility from "../services/Utility";

class EgpFormField extends Component {
  constructor(props) {
    super(props);
    //this.state = { value: this.props.value };
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.input = React.createRef();
    this.select = React.createRef();
  }

  componentDidUpdate(prevProps) {
    /* console.log('EgpFormField', 'name:', this.props.name);
    console.log('EgpFormField', 'componentDidUpdate', 'props:', this.props.hasFocus);
    console.log('EgpFormField', 'componentDidUpdate', 'prevProps.hasFocus:', prevProps.hasFocus); */
    var that = this;
    if (this.props.hasFocus) {
      setTimeout(function () {
        that.input.current.focus();
      });
    }
  }

  handleFocus(event) {
    console.log("handleFocus", "event.target:", event.target);
    console.log("handleFocus", "this.select.current:", this.select.current);
    this.select.current.focus();
    //let value = event.target.value;
    //this.setState({ value: value });
    //this.props.onChange(this.props.name, value);
  }

  handleChange(event) {
    let value = event.target.value;
    //this.setState({ value: value });
    this.props.onChange(this.props.name, value);
  }

  render() {
    // input value={this.state.value} value={this.props.value}
    const { className, classList, name, placeholder, type, value } = this.props;
    const classSet = Utility.classSet(classList);
    const options = Array.isArray(this.props.options)
      ? [...this.props.options]
      : [];

    // 1. split default + others
    const defaultOptions = options.filter((o) => o.value === "default");
    const otherOptions = options.filter((o) => o.value !== "default");

    // 2. sort ONLY the others
    otherOptions.sort((a, b) => (a.label || "").localeCompare(b.label || ""));

    // 3. merge back together
    const sortedOptions = [...defaultOptions, ...otherOptions];
    //const field =
    return (
      <div className={className}>
        {type === "select" ? (
          <div>
            <select
              id={name}
              name={name}
              className={"inputstyle selectStyle " + classSet}
              value={value}
              onChange={this.handleChange}
              // style={{padding:"10px 12px"}}
              ref={this.select}
            >
              {sortedOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <div className="icon">
              <span></span>
            </div>
          </div>
        ) : type === "text" || type === "password" || type === "file" ? (
          <div className={classSet}>
            <input
              type={type}
              name={name}
              className="inputstyle"
              value={value}
              placeholder={placeholder}
              onChange={this.handleChange}
              ref={this.input}
            />
          </div>
        ) : type === "textarea" ? (
          <div className={classSet}>
            <textarea
              name={name}
              value={value}
              className="upload_image_textarea"
              placeholder={placeholder}
              onChange={this.handleChange}
              ref={this.input}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default EgpFormField;

/* var formData = new FormData();

formData.append("username", "Groucho");
formData.append("accountnum", 123456); // number 123456 is immediately converted to a string "123456"

// HTML file input, chosen by user
formData.append("userfile", fileInputElement.files[0]); */
